var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInGameFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 .5a1 1 0 011 1V2a1 1 0 01-.02.196C18.553 3.115 22 7.155 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12c0-4.845 3.445-8.885 8.02-9.804A1.007 1.007 0 0110 2v-.5a1 1 0 011-1h2zm-1 5.75a.75.75 0 00-.75.75v3.146a2 2 0 101.5 0V7a.75.75 0 00-.75-.75z",
    fill: "currentColor"
  })));
}
SvgInGameFilled.displayName = 'InGameFilled';
export default SvgInGameFilled;